var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.844 0 0 114.844 0 256s114.844 256 256 256 256-114.844 256-256S397.156 0 256 0zm0 74.667c67.635 0 122.667 55.031 122.667 122.667S323.635 320 256 320s-122.667-55.031-122.667-122.667S188.365 74.667 256 74.667zm0 394.666c-69.707 0-131.52-33.755-170.473-85.615 42.676-20.534 103.621-42.385 170.473-42.385 66.857 0 127.807 21.854 170.474 42.383-38.953 51.861-100.766 85.617-170.474 85.617z"
  })));
}

export default SvgUser;